import { FunctionComponent, PropsWithChildren } from 'react';

const ErrorCard: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <div className="col card responsive-spacing">
      <div className="card-content">
        <div className={`card-body responsive-spacing pt-2 pb-4`}>{children}</div>
      </div>
    </div>
  );
};

export default ErrorCard;
